module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Light.c0b7644.woff";